<script setup="">
import { usePullToRefresh } from "@/composables/usePullToRefresh";

const pullToRefresh = usePullToRefresh();
</script>

<template>
  <div v-bind="$attrs" class="pull-to-refresh-container">
    <slot :ptr="pullToRefresh"></slot>
  </div>
</template>
